import { visit, Kind } from 'graphql';

export const queryAllPages = async (client, options, { pageSize = 250, maxRecords = 10000 } = {}) => {
  const operation = options.query.definitions.find(definition => definition.kind === Kind.OPERATION_DEFINITION);
  const field = operation?.selectionSet.selections.find(selection => selection.kind === Kind.FIELD);
  const children = field?.selectionSet?.selections.map(selection => selection.name?.value) || [];
  if (!children.includes('data') || !children.includes('totalRecords')) return client.query(options);
  const rootKey = field.alias?.value || field.name.value;
  const query = visit(options.query, {
    OperationDefinition(node) {
      const existing = new Set((node.variableDefinitions || []).map(definition => definition.variable.name.value));
      return { ...node, variableDefinitions: [...(node.variableDefinitions || []), ...['limit', 'offset'].filter(name => !existing.has(name)).map(name => ({ kind: Kind.VARIABLE_DEFINITION, variable: { kind: Kind.VARIABLE, name: { kind: Kind.NAME, value: name } }, type: { kind: Kind.NON_NULL_TYPE, type: { kind: Kind.NAMED_TYPE, name: { kind: Kind.NAME, value: 'Int' } } } }))] };
    },
    Field(node) {
      if (node !== field) return undefined;
      const args = (node.arguments || []).filter(argument => !['limit', 'offset'].includes(argument.name.value));
      return { ...node, arguments: [...args, ...['limit', 'offset'].map(name => ({ kind: Kind.ARGUMENT, name: { kind: Kind.NAME, value: name }, value: { kind: Kind.VARIABLE, name: { kind: Kind.NAME, value: name } } }))] };
    },
  });
  let response;
  const rows = [];
  for (let offset = 0; offset < maxRecords; offset += pageSize) {
    response = await client.query({ ...options, query, variables: { ...options.variables, limit: Math.min(pageSize, maxRecords - offset), offset } });
    const page = response.data?.[rootKey];
    if (!page || !Array.isArray(page.data) || !Number.isFinite(page.totalRecords)) throw new Error('Invalid lookup response');
    if (page.totalRecords > maxRecords) { const error = new Error('Lookup limit exceeded'); error.status = 400; throw error; }
    rows.push(...page.data);
    if (!page.data.length && rows.length < page.totalRecords) throw new Error('Incomplete lookup response');
    if (rows.length >= page.totalRecords) return { ...response, data: { ...response.data, [rootKey]: { ...page, data: rows } } };
  }
  const error = new Error('Lookup limit exceeded'); error.status = 400; throw error;
};
